services.service('CustomerEventsService', [
    '$q', '$window',
    function ($q, $window) {
        var self = this;

        var sessionPingTimer;

        this.events = {
            InsufficientFunds: "insufficientFunds",
            MarginCall: "marginCall",
            TradeOpen: "tradeOpen",
            TradeClose: "tradeClose",
            TradeUpdate: "tradeUpdate",
            TradeCancel: "tradeCancel",
            BalanceUpdate: "balanceUpdate",
            MarginUtilization: "marginUtilization"
        };

        this.trackEvent = function (type, event) {
            if (!$window.parent) {
                return;
            }

            $window.parent.postMessage({
                source: 'nfp',
                event: 'cfd:' + type,
                payload: event,
            }, '*')
        }

        this.startSessionPing = function (user) {
            sessionPingTimer = setInterval(function () {
                self.trackEvent('online', {customer: user.getCustomer()})
            }, 10000)
        }

        this.stopSessionPing = function () {
            if (sessionPingTimer) {
                clearInterval(sessionPingTimer);
            }
        }

        return this;
    }
]);
